/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Legajox_Org_Chart_SuccessInputs */

const es_tools_legajox_org_chart_success = /** @type {(inputs: Tools_Legajox_Org_Chart_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organigrama de Legajox obtenido`)
};

const en_tools_legajox_org_chart_success = /** @type {(inputs: Tools_Legajox_Org_Chart_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legajox org chart retrieved`)
};

/**
* | output |
* | --- |
* | "Legajox org chart retrieved" |
*
* @param {Tools_Legajox_Org_Chart_SuccessInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_legajox_org_chart_success = /** @type {((inputs?: Tools_Legajox_Org_Chart_SuccessInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Legajox_Org_Chart_SuccessInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_legajox_org_chart_success(inputs)
	return en_tools_legajox_org_chart_success(inputs)
});
export { tools_legajox_org_chart_success as "tools.legajox.org_chart_success" }